import * as React from 'react';

export interface ScrollerContextValue {
    onChangeActiveItem: (element: HTMLElement | null) => void;
}

export const ScrollerContext = React.createContext<ScrollerContextValue | undefined>(undefined);

export function useScrollerContext(): ScrollerContextValue | undefined {
    return React.useContext(ScrollerContext);
}
